<div class="engi-prod-select-config">

  <form
        id="bpr_prodCL-form"
        action="/cart/addContactLensRange"
        class="engi-form-styled bpr_form-styled"
        autocomplete="false"
        novalidate
  >
    <div class="engi-prod-strength-wrapper">

      <label class="engi-prod-choice ">
        <input type="checkbox" class="a-checkbox" (change)="resetLensSelections($event.target.checked)" name="eyesIdentical">
        <span class="engi-prod-one-value flaticon-tick">{{'configurator.lenses.this.same.text' | translate }}</span>
        <span class="engi-prod-one-value engi-prod-one-value-ve flaticon-tick">{{'configurator.lenses.this.same.text.ve' | translate }}</span>
      </label>
      <div class="engi-prod-lenses-option" [ngClass]="{ '--checked': formData.eyesIdentical }">
        <div>
        <div class="engi-prod-lenses-option-wrapper">
            <div class="engi-prod-eye --once"><span class="engi-prod-eye__content">{{'configurator.lenses.right.text' | translate }}</span></div>
            <div class="engi-prod-eye --once"><span class="engi-prod-eye__content">{{ 'configurator.lenses.left.text' | translate}}</span></div>
            <div class="engi-prod-eye --both"><span class="--both__content">{{'configurator.lenses.both.text' | translate }}</span></div>
        </div>
        </div>
      </div>
    </div>
    <div class="engi-prod-eyes-configure" *ngIf="lense"  [ngClass]="{ '--checked': formData.eyesIdentical }">
        <div class="engi-prod-select-param" *ngFor="let len of lense">


          <span class="engi-prod-content">{{len.flow}}<span></span></span>
          <div class="engi-prod-var-cont" >
            <div class="engi-prod-variants --col-1 flaticon-down-arrow">
              <select
                tabindex="1"
                name="curvature"
                class="config"
                [disabled]="len?.right.disable"
                [ngClass]="{ '--disabled': len?.right.disable }"
                ng-model="right"
                (change)="onChange($event.target.value, 'right', len.index, len.code)"
              >
                <option [value]="null"
                        [hidden]="len.right.showDefaultValue()"
                        [disabled]="len.right.showDefaultValue()"
                        [style.display]="len.right.showDefaultValue() ? 'none' : 'block'"
                >{{'configurator.lenses.get.text' | translate }}</option>

                <option
                  *ngFor="let val of len.right.values"
                  [value]="val"
                  [selected]="val === len.right.selectValue"
                  [hidden]="val === len.right.selectValue"
                >
                  {{len.index === 1 && val>0 && val.slice(0,1) !== '+' ? '+'+val : val}}
                </option>
              </select>
            </div>
            <div class="engi-prod-variants --col-2 flaticon-down-arrow">
              <select
                tabindex="2"
                name="curvature"
                class="config"
                [disabled]="len?.left.disable"
                [ngClass]="{ '--disabled': len?.left.disable }"
                ng-model="left"
                (change)="onChange($event.target.value, 'left', len.index, len.code)"
              >
                <option [value]="null"
                        [hidden]="len.left.showDefaultValue()"
                        [disabled]="len.left.showDefaultValue()"
                        [style.display]="len.left.showDefaultValue() ? 'none' : 'block'"
                >{{'configurator.lenses.get.text' | translate }}</option>
                <option
                  *ngFor="let val of len.left.values"
                  [value]="val"
                  [selected]="val === len.left.selectValue"
                  [hidden]="val === len.left.selectValue"
                >
                  {{len.index === 1 && val>0 && val.slice(0,1) !== '+' ? '+'+val : val}}
                </option>
              </select>
            </div>
          </div>
        </div>

      <div class="engi-prod-select-param lens-quantity">
        <span class="engi-prod-content">{{'configurator.lenses.quantity.text' | translate }}</span>

        <div class="engi-prod-var-cont">

          <div class="engi-prod-quantity-wrapper">

            <div class="engi-prod-select-qua --col-1">
              <div class="engi-prod-qua-minus flaticon-minus"
                   (click)="decQuantity(formData.rightEye, 'right')"
                   [ngClass]="{'--invisible': !showDecButton(formData.rightEye)}"
              ></div>

              <input type="hidden"
                     name="rightQuantity"
                     [value]="formData.rightEye.quantity"
                     readonly
              >
              <div class="engi-prod-qua">{{ formData.rightEye.quantity }}</div>

                <div class="engi-prod-qua-plus flaticon-plus"
                     (click)="incQuantity(formData.rightEye, 'right')"
                     [ngClass]="{'--invisible': !showIncButton(formData.rightEye)}"
                ></div>
              </div>

              <div class="engi-prod-select-qua --col-2">
                <div class="engi-prod-qua-minus flaticon-minus"
                     (click)="decQuantity(formData.leftEye, 'left')"
                     [ngClass]="{'--invisible': !showDecButton(formData.leftEye)}"
                ></div>

                <input type="hidden"
                       name="leftQuantity"
                       [value]="formData.leftEye.quantity"
                       readonly
                >
                <div class="engi-prod-qua">{{ formData.leftEye.quantity }}</div>

                <div class="engi-prod-qua-plus flaticon-plus"
                     (click)="incQuantity(formData.leftEye, 'left')"
                     [ngClass]="{'--invisible': !showIncButton(formData.leftEye)}"
                >
                </div>
            </div>
          </div>

        </div>
      </div>

      <p class="engi-prod-eye-deliverytime" *ngIf="deliveryLeadTimeText">
        {{deliveryLeadTimeText}}
      </p>

    </div>
    <input type="hidden"
           id="productCode"
           name="productCode"
           [value]="formData.productCode"
           readonly
    >
    <input type="hidden"
           name="eyesIdentical"
           [value]="formData.eyesIdentical"
           readonly
    >
    <input type="hidden"
           id="leftRangeUid"
           name="leftRangeUid"
           [value]="formData.leftEye.rangeUid"
           readonly
    >
    <input type="hidden"
           id="leftGroupUid"
           name="leftGroupUid"
           [value]="formData.leftEye.groupUid"
           readonly
    >
    <input type="hidden"
           name="rightRangeUid"
           [value]="formData.rightEye.rangeUid"
           readonly
    >
    <input type="hidden"
           name="rightGroupUid"
           [value]="formData.rightEye.groupUid"
           readonly
    >
  </form>
</div>
